var PrayerList = [
    {
        "tib":"སྔོན་འགྲོ།2021-05-21-V2",
        "chin":"Ngondro2021-05-21-V2",
        "eng":"Ngondro2021-05-21-V2",
        "filename":"Ngondro2021-05-21-V2.docx"
    },
    {
        "tib":"སྔོན་འགྲོ།Ngondro2021-06-19-V2",
        "chin":"Ngondro2021-06-19-V2",
        "eng":"Ngondro2021-06-19-V2",
        "filename":"Ngondro2021-06-19-V2.docx"
    },
    {
        "tib":"སྣང་སྲིད་དབང་འདུས།",
        "chin":"NangsidWangdu",
        "eng":"NangsidWangdu",
        "filename":"02 NangsidWangdu.json"
    },
    {
        "tib":"སྨན་ཆོག",
        "chin":"MedizinBuddhaPrayer-V2",
        "eng":"MedizinBuddhaPrayer-V2",
        "filename":"MedizinBuddhaPrayer2020-05-12-V2.docx"
    },
    {
        "tib":"གསོལ་ཀ་བསྡུས་པ།",
        "chin":"MahakalaDupa-V2",
        "eng":"MahakalaDupa-V2",
        "filename":"MahakalaDupa2020-05-12-V2.docx"
    },
    {
        "tib":"བསྐོང་བཤགས།",
        "chin":"Kongshag-V2",
        "eng":"Kongshag-V2",
        "filename":"Kongshag2020-05-12-V2.docx"
    },
    {
        "tib":"ཚོགས་བསྡུས།",
        "chin":"Tsodu-V2",
        "eng":"Tsodu-V2",
        "filename":"Tsodu2020-05-12-V2.docx"
    },
    {
        "tib":"བདེ་སྨོན།",
        "chin":"Demon-V2",
        "eng":"Demon-V2",
        "filename":"Demon2021-05-23-V2.docx"
    },
    {
        "tib":"བསྔོ་སྨོན།",
        "chin":"NgowaMonlam-V2",
        "eng":"NgowaMonlam-V2",
        "filename":"NgowaMonlam2020-05-12-V2.docx"
    },
    {
        "tib":"༠༨ བདེ་ཆེན་ཞིང་སྒྲུབ་བསྡུས་པ།",
        "chin":"08 極樂淨土修持簡軌",
        "eng":"08 Dechen Zhingdrub Short",
        "filename":"08 Dechen Zhingdrub Short-V2.docx"
    },
    {
        "tib":"བདེ་སྨོན།",
        "chin":"極樂淨土發願文",
        "eng":"Demon",
        "filename":"Demon2021-05-23-V2.docx"
    },
    {
        "tib":"གསོལ་ཀ།",
        "chin":"護法",
        "eng":"Mahakala",
        "filename":"Mahakala-V2.docx"
    },
    {
        "tib":"ཨ་བ་ཁ་འདོན།",
        "chin":"阿爸課本",
        "eng":"AbaKhandon",
        "filename":"AbaKhandon-V2.docx"
    },
    {
        "tib":"བླ་མ་རིག་འཛིན་འདུས་པ།",
        "chin":"上師持明總集",
        "eng":"LamaRigzinDupa",
        "filename":"RigzinDupa-V2.docx"
    },
    {
        "tib":"སྒྲོལ་མ་ཉེར་གཅིག",
        "chin":"二十一度母",
        "eng":"Tara21",
        "filename":"Tara21-2021-06-25-V2.docx"
    },
    {
        "tib":"བཟང་སྤྱོད།",
        "chin":"普賢行願品",
        "eng":"Zangchod",
        "filename":"Zangchod-V2.docx"
    },
    {
        "tib":"བདེ་ཆེན་ཞི་སྒྲུབ་རྒྱས་པ།",
        "chin":"極樂淨土修持長軌",
        "eng":"Dechen Zhidrub",
        "filename":"Dechen Zhidrub2020-06-29-V2.docx"
    },
    {
        "tib":"མཁའ་འགྲོ་བདེ་ཆེན་རྒྱལ་མོ།",
        "chin":"gyalmo",
        "eng":"gyalmo",
        "filename":"KhandroDechenGyalmo-V2.docx"
    },
    {
        "tib":"ཛམ་བྷ་ལ་ནག་པོའི་ཆུ་སྦྱིན་གྱི་ཆོ་ག་",
        "chin":"ZamNagChuJin",
        "eng":"ZamNagChuJin",
        "filename":"ZamNagGuruChosWang2-V2.docx"
    },
    {
        "tib": "སྨན་ཆོག་དང་བདེ་སྨོན་ཚོགས་པ།",
        "chin": "Medizin & Amitaba",
        "eng": "Medizin & Amitaba",
        "filename": "Ngondro2021-06-19-V2.docx;MedizinBuddhaPrayer2020-05-12-V2.docx;Demon2021-05-23-V2.docx;NgowaMonlam2020-05-12-V2.docx"
    },
    {
        "tib": "འོད་དཔག་བྱང་ཚོག་ཚོགས་པ།",
        "chin": "Wodpag Jangchog Prayer",
        "eng": "Wodpag Jangchog Prayer",
        "filename": "Ngondro2021-06-19-V2.docx;Dechen Zhidrub2020-06-29-V2.docx;MahakalaDupa2020-05-12-V2.docx;Kongshag2020-05-12-V2.docx;Tsodu2020-05-12-V2.docx;JangChogWumed2020-05-02-V2.docx;Demon2021-05-23-V2.docx;NgowaMonlam2020-05-12-V2.docx"
    },
    {
        "tib": "བདེ་ཆེན་ཞིང་སྒྲུབ་ཀྱི་བྱང་ཆོག",
        "chin": "JangChogWumed2020-05-02-V2",
        "eng": "JangChogWumed2020-05-02-V2",
        "filename": "JangChogWumed2020-05-02-V2.docx"
    },
    // {
    //     "tib": "Test01V2",
    //     "chin": "Test01V2",
    //     "eng": "Test01V2",
    //     "filename": "Test01V2.docx"
    // },
    // {
    //     "tib": "zangchodchinese02-V2",
    //     "chin": "zangchodchinese02-V2",
    //     "eng": "zangchodchinese02-V2",
    //     "filename": "zangchodchinese02-V2.docx"
    // },
    {
        "tib": "རིག་འཛིན་འདུས་པའི་ཚོགས་བསྐང་། ",
        "chin": "蓮師持明總集薈供",
        "eng": "Rigzin Dupa Tsogkang",
        "filename": "Ngondro2021-06-19-V2.docx;RigzinDupa02Lejang2021-06-19-V2.docx;MahakalaDupa2020-05-12-V2.docx;Kongshag2020-05-12-V2.docx;Tsodu2020-05-12-V2.docx;Demon-Dupa2021-05-23-V2.docx;NgowaMonlam2020-05-12-V2.docx"
    },
    {
        "tib": "ཡུམ་ཀ་བདེ་ཆེན་རྒྱལ་མོའི་ཚོགས་བསྐང་བསྡུས་པ། ",
        "chin": "龍欽心滴大樂空行母薈供",
        "eng": "Yumka Dechen Gyalmo Tsogkang",
        "filename": "Ngondro2021-06-19-V2.docx;KhandroDechenGyalmo-Lejang-V2.docx;MahakalaDupa2020-05-12-V2.docx;Kongshag2020-05-12-V2.docx;Tsodu2020-05-12-V2.docx;Demon-Dupa2021-05-23-V2.docx;NgowaMonlam2020-05-12-V2.docx"
    },
    {
        "tib": "སེམས་བསྐྱེད་སྡོམ་ཆོག ",
        "chin": "菩薩戒略軌",
        "eng": "Bodhisattva Vow",
        "filename": "Jangdom01%20Timug%20Nyitrog2022-07-24.docx;Jangdom02%20Zangchod%20Yenlag%20Dunpa2022-07-24.docx;Jangdom03%20Semshed%20Choga2022-07-24.docx"
    },
    {
        "tib": "ལྟུང་བཤགས་དང་སེམས་བསྐྱེད་སྡོམ་ཆོག ",
        "chin": "喚醒痴夢、菩薩懺墮經及菩薩戒略軌",
        "eng": "Confession of Downfalls and Bodhisattva Vow",
        // "filename": "Jangdom01%20Timug%20Nyitrog2022-07-24.docx;Jangdom04%20TungShag2022-07-24.docx;Jangdom03%20Semshed%20Choga2022-07-24.docx",
        "filename":"NgondroPrayerBook2022-01-16(0)Ngondro-short.docx;Jangdom01 Timug Nyitrog2022-09-04.docx;Jangdom04 TungShag2022-09-04.docx;Jangdom03 Semshed Choga2022-09-04.docx;NgondroPrayerBook2022-01-16(5)Ngowa.docx"
    },

];
var FontList = [
    {tib:'Himalaya',chin:'Himalaya',eng:'Himalaya',fontName:"Himalaya"},
    {tib:'Sambotha',chin:'Sambotha',eng:'Sambotha',fontName:"Sambhota"},
    {tib:'Jomolhari',chin:'Jomolhari',eng:'Jomolhari',fontName:"Jomolhari"},

    {tib:'MonlamUniOuChan2',chin:'MonlamUniOuChan2',eng:'MonlamUniOuChan2',fontName:"MonlamUniOuChan2"},
    // {tib:'MonlamUniOuChan2New',chin:'MonlamUniOuChan2New',eng:'MonlamUniOuChan2New',fontName:"MonlamUniOuChan2New"},

    // {tib:'UmePechug',chin:'UmePechug',eng:'UmePechug',fontName:"UmePechug"},
    {tib:'Sadris',chin:'Sadris',eng:'Sadris',fontName:"GologDernangSadris-Yigchen"}
];

export {PrayerList, FontList}